'use client';

import Conditional from '@next-app/components/Conditional';
import { ProductModalsProps } from '@next-app/interface/PDP/PDPProductView';
import getDevice from '@next-app/components/HOC/GetDevice';
import dynamic from 'next/dynamic';

const DesktopProductModal = dynamic(() => import('./DesktopProductModal'), {
  ssr: true,
});
const MobileProductModal = dynamic(() => import('./MobileProductModal'), {
  ssr: true,
});
const AudioModal = dynamic(() => import('./AudioModal'), { ssr: true });

const ProductModals = (props: ProductModalsProps) => {
  const { isWeb, isTab, isMobile, isAudioAvailable = false } = props;

  return (
    <>
      <Conditional if={isWeb}>
        <DesktopProductModal {...props} />
      </Conditional>
      <Conditional if={isAudioAvailable}>
        <AudioModal {...props} />
      </Conditional>
      <Conditional if={isMobile || isTab}>
        <MobileProductModal {...props} />
      </Conditional>
    </>
  );
};

export default getDevice(ProductModals);
